import React from 'react';
import { motion } from 'framer-motion';

const trustedBy = [
  {
    name: 'Red Ventures',
    logo: '/assets/logos/red-ventures.png',
    logoHeight: 'h-10',
  },
  {
    name: 'Sage Home Loans',
    logo: '/assets/logos/sage-home-loans.svg',
    logoHeight: 'h-8',
  },
  {
    name: 'MTC',
    logo: '/assets/logos/mtc.png',
    logoHeight: 'h-12',
  },
  {
    name: 'Wait Works LLC',
    logo: '/assets/logos/wait-works.png',
    logoHeight: 'h-14',
  },
  {
    name: 'Ember',
    logo: '/assets/logos/ember.png',
    logoHeight: 'h-10',
  },
];

const educatedAt = [
  {
    name: 'BYU Marriott School of Business',
    logo: '/assets/logos/byu-marriott.svg',
    logoHeight: 'h-8',
  },
];

function LogoItem({ item, delay }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay, duration: 0.2 }}
      className="flex flex-col items-center gap-2 group cursor-default select-none"
    >
      <div className="flex items-center justify-center h-16">
        <img
          src={item.logo}
          alt={item.name}
          className={`${item.logoHeight} w-auto object-contain transition-transform duration-300 group-hover:scale-105`}
        />
      </div>
      <span className="text-xs font-medium text-gray-400 dark:text-gray-500 group-hover:text-gray-600 dark:group-hover:text-gray-400 transition-colors duration-300 text-center leading-tight">
        {item.name}
      </span>
    </motion.div>
  );
}

function LogoCloud() {
  return (
    <section className="py-14 bg-white dark:bg-gray-900 border-y border-gray-100 dark:border-gray-800">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 space-y-10">

        <div>
          <p className="text-center text-xs font-semibold uppercase tracking-widest text-gray-300 dark:text-gray-600 mb-8">
            Trusted by
          </p>
          <div className="flex flex-wrap items-center justify-center gap-10 md:gap-16">
            {trustedBy.map((item, i) => (
              <LogoItem key={item.name} item={item} delay={i * 0.05} />
            ))}
          </div>
        </div>

        <div className="border-t border-gray-100 dark:border-gray-800" />

        <div>
          <p className="text-center text-xs font-semibold uppercase tracking-widest text-gray-300 dark:text-gray-600 mb-8">
            Educated at
          </p>
          <div className="flex flex-wrap items-center justify-center gap-10 md:gap-16">
            {educatedAt.map((item, i) => (
              <LogoItem key={item.name} item={item} delay={i * 0.05} />
            ))}
          </div>
        </div>

      </div>
    </section>
  );
}

export default LogoCloud;
